import React from 'react';
import { Paper, Typography, Box, Chip, Stack, Button } from '@mui/material';
import { Add as AddIcon, Edit as EditIcon } from '@mui/icons-material';

const TestInfoCard = ({ test, questionsCount, onAddQuestion, onEditTest }) => {
  const testTypes = [
    { value: "SURVEY", label: "Survey" },
    { value: "DEPRESSION", label: "Depression" },
    { value: "ANXIETY", label: "Anxiety" },
    { value: "EMOTIONAL_INTELLIGENCE", label: "Emotional Intelligence" },
    { value: "EMPATHY", label: "Empathy" },
    { value: "MENTAL_WELLBEING", label: "Mental Wellbeing" },
    { value: "SOCIAL_PHOBIA", label: "Social Phobia" },
    { value: "WHITE_BEAR_SUPPRESSION", label: "White Bear Suppression" },
    { value: "EATING_BEHAVIOR", label: "Eating Behavior" }
  ];

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" gutterBottom>
        {test.name}
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        {test.description}
      </Typography>
      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <Chip 
          label={testTypes.find(t => t.value === test.type)?.label || test.type}
          color="primary"
        />
        <Chip 
          label={`${questionsCount} Questions`}
          variant="outlined"
        />
      </Box>
      <Typography variant="body2" paragraph>
        <strong>Instructions:</strong> {test.instructions}
      </Typography>
      {test.imageUrl && (
        <Typography variant="body2" paragraph>
          <strong>Image URL:</strong> {test.imageUrl}
        </Typography>
      )}
      
      <Stack direction="row" spacing={2} mt={2}>
        <Button 
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAddQuestion}
        >
          Add New Question
        </Button>
        <Button 
          variant="outlined"
          startIcon={<EditIcon />}
          onClick={onEditTest}
        >
          Edit Test
        </Button>
      </Stack>
    </Paper>
  );
};

export default TestInfoCard;